module.exports = __webpack_public_path__ + "gfx/IR-29.png";